import { ReactNode, createContext, useContext, useState } from 'react';
import useFetchHubSpotDropdownData from '../hooks/useApi/useFetchHubSpotDropdownData';

import type { HubSpotDropdownData } from '../hooks/useApi/useFetchHubSpotDropdownData';

type HubSpotDropdownDataSet = {
  hubSpotDropDownData: {
    platformUsagesDropDownOptions: { [key: string]: string };
    platformUsagesMappedValues: { [id: string]: HubSpotDropdownData };
    industriesDropDownOptions: { [key: string]: string };
    industriesMappedValues: { [id: string]: HubSpotDropdownData };
  };
  refreshHubSpotDropdownData: (options?: { useCached: boolean }) => void;
  dealCountry: string;
  setDealCountry: (dealCountry: string) => void;
};

export const HubSpotDropdownDataContext = createContext<HubSpotDropdownDataSet>({
  hubSpotDropDownData: {
    platformUsagesDropDownOptions: {},
    platformUsagesMappedValues: {},
    industriesDropDownOptions: {},
    industriesMappedValues: {},
  },
  refreshHubSpotDropdownData: () => {},
  dealCountry: '',
  setDealCountry: () => {},
});

export const HubSpotDropdownDataSetProvider = ({ children }: { children: ReactNode }): React.JSX.Element => {
  const [hubSpotDropDownData, refreshHubSpotDropdownData] = useFetchHubSpotDropdownData({});
  const [dealCountry, setDealCountry] = useState('');

  return (
    <HubSpotDropdownDataContext.Provider
      value={{
        hubSpotDropDownData,
        refreshHubSpotDropdownData,
        dealCountry,
        setDealCountry,
      }}
    >
      {children}
    </HubSpotDropdownDataContext.Provider>
  );
};

export const useHubSpotDropdownDataSet = (): HubSpotDropdownDataSet => useContext(HubSpotDropdownDataContext);
